import React, { useEffect, useState } from "react";
import { FlooringCaseSummaryUrl, FlooringPdfBaseUrl, FlooringSOAUrl } from "../../common/Constants";

const PdfViewer = ({ AppId, AgentId, title, type, StartDate,
  EndDate }) => {
  console.log("PDFPROPS", AppId, AgentId, title, type, StartDate,
    EndDate)
  const headerHeight = 68; // Height of the header in pixels
  const footerHeight = 64; // Height of the footer in pixels
  const GetBaseUrl = (type) => {
    console.log('type=====',type)
    if (type === "CASE") {
      return FlooringCaseSummaryUrl;
    } else if (type === "AAF") {
      return FlooringPdfBaseUrl;
    } else if (type === "SOA") {
      return FlooringSOAUrl;
    } else {
      return "";
    }
  };

  const [iframeHeight, setIframeHeight] = useState('500px');



  //pdfUrl;

  useEffect(() => {
    // Function to update the height of the iframe
    const updateIframeHeight = () => {
      const newHeight = window.innerHeight - headerHeight - footerHeight;
      setIframeHeight(`${newHeight}px`);
    };

    // Update the iframe height when the component mounts
    updateIframeHeight();

    // Add event listener for window resize
    window.addEventListener('resize', updateIframeHeight);

    // Cleanup the event listener
    return () => window.removeEventListener('resize', updateIframeHeight);
  }, []);

  return (
    <>
      {AppId !== undefined && AgentId !== undefined ? (
        <iframe
          src={type === "SOA" ? `${GetBaseUrl(type)}${AppId}/${StartDate}/${EndDate}` :
            type === "CASE" ?
              `${GetBaseUrl(type)}${AppId}`
              : `${GetBaseUrl(type)}${AppId}/${AgentId}`}
          title={title || "PDF Viewer"}
          style={{ width: "100%", height: iframeHeight }}
        />
      ) : (
        <iframe
          src={""}
          title={"PDF Viewer"}
          style={{ width: "100%", height: iframeHeight }}
        />
      )}
    </>
  );
};

export default PdfViewer;
